import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkLocationMembersComponent } from './network-location-members.component';
import { PageContainerModule } from '@zelis/platform-ui-components';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { GlobalMembersDropdownModule } from '../members';
import { GlobalNetworkDropdownModule } from '../global-header/network/global-network-dropdown.module';
import { GlobalLocationSelectModule } from '../global-header/location/global-location-select.module';
import { SaveForPrintModule } from '@components/save-for-print/save-for-print.module';
import { NetworkSelectionDropdownModule } from '@components/network-selection-dropdown/network-selection-dropdown.module';

@NgModule({
  declarations: [NetworkLocationMembersComponent],
  imports: [
    CommonModule,
    PageContainerModule,
    FlexLayoutModule,
    GlobalMembersDropdownModule,
    GlobalNetworkDropdownModule,
    GlobalLocationSelectModule,
    SaveForPrintModule,
    NetworkSelectionDropdownModule,
  ],
  exports: [NetworkLocationMembersComponent],
})
export class NetworkLocationMembersModule {}
